import FacebookRoundedIcon from "@mui/icons-material/FacebookRounded"
import XIcon from "@mui/icons-material/X"
import Instagram from "@mui/icons-material/Instagram"
import GitHub from "@mui/icons-material/GitHub"
import LinkedInIcon from "@mui/icons-material/LinkedIn"
import MailOutlinedIcon from "@mui/icons-material/MailOutlined"
import CallOutlinedIcon from "@mui/icons-material/CallOutlined"
import WhatsAppIcon from "@mui/icons-material/WhatsApp"
import MastodonIcon from "../../../components/mastodonIcon"

export const LimitTeam = [
  {
    name: "Arghyadip Chakraborty",
    image: "ArghyadipChakraborty.jpg",
    site: "https://arghyac.com",
    socialUserNames: {
      Instagram: "arghyadipchak",
      GitHub: "arghyadipchak",
      LinkedIn: "arghyadipchak",
      Email: "dev@arghyac.com"
    },
    teams: ["tech"],
    course: "MS IIT Bombay",
    year: "2nd"
  },
  {
    name: "Atreya Choudhury",
    image: "Atreya.jpeg",
    site: "https://www.atchox.com",
    socialUserNames: {
      LinkedIn: "atreyachoudhury",
      GitHub: "atchox",
      Instagram: "_atchox_"
    },
    teams: ["tech"],
    course: "MSc ETH Zürich",
    year: "2nd"
  },
  {
    name: "Bikram Halder",
    image: "BikramHalder.jpg",
    socialUserNames: {
      Mastodon: "mathstodon.xyz/@ProwessJ",
      GitHub: "BikramHalder",
      Email: "bikram0x@outlook.com"
    },
    teams: ["tech"],
    course: "M. Math",
    year: "2nd"
  },
  {
    name: "Hrishik Koley",
    image: "Hrishik.jpeg",
    site: "https://hrishik-koley.github.io/",
    socialUserNames: {
      Instagram: "_mortal_devil_",
      GitHub: "Hrishik-Koley",
      Email: "hrishik.math@outlook.com"
    },
    teams: ["tech", "core"],
    course: "M. Math",
    year: "1st"
  },
  {
    name: "Siddharto Das",
    image: "SiddhartoDas.jpg",
    socialUserNames: {
      GitHub: "siddharto-das"
    },
    teams: ["tech"],
    course: "B. Math",
    year: "2nd"
  },
  {
    name: "Rinkiny Ghatak",
    image: "RinkinyGhatak.jpg",
    socialUserNames: {
      Instagram: "rinkiny_ghatak",
      Email: "rinkinyghatak@gmail.com"
    },
    teams: ["comms", "core"],
    course: "M. Math",
    year: "1st"
  },
  {
    name: "Pranav Agarwal",
    image: "PranavAgarwal.jpg",
    socialUserNames: {
      Instagram: "prnav_06"
    },
    teams: ["comms"],
    course: "B. Math",
    year: "3rd"
  },
  {
    name: "Shrajal Kushwaha",
    image: "ShrajalKushwaha.jpg",
    socialUserNames: {
      Instagram: "k_shrajal_",
      LinkedIn: "shrajal-kushwaha-05a979288"
    },
    teams: ["comms"],
    course: "B. Math",
    year: "3rd"
  },
  {
    name: "Nirjhar Laskar",
    image: "NirjharLaskar.jpg",
    socialUserNames: {
      Instagram: "laskarnirjhar"
    },
    teams: ["qst"],
    course: "B. Math",
    year: "3rd"
  },
  {
    name: "Nikhil Nagaria",
    image: "NikhilNagaria.jpeg",
    socialUserNames: {
      Instagram: "nikhil0112358"
    },
    teams: ["qst"],
    course: "M. Math",
    year: "1st"
  },
  {
    name: "Souparna Pal",
    image: "SouparnaPal.jpg",
    socialUserNames: {
      Twitter: "souparna25",
      LinkedIn: "souparna-pal-113290324",
      Email: "souparna25pal@gmail.com"
    },
    teams: ["qst", "core"],
    course: "B. Math",
    year: "2nd"
  },
  {
    name: "Sayan Dewan",
    image: "SayanDewan.jpeg",
    socialUserNames: {
      Email: "bmat2340@isibang.ac.in"
    },
    teams: ["comms"],
    course: "B. Math",
    year: "2nd"
  },
  {
    name: "Anuvab De",
    image: "AnuvabDe.jpg",
    socialUserNames: {
      Instagram: "anuvabde"
    },
    teams: ["comms"],
    course: "B. Math",
    year: "2nd"
  },
  {
    name: "Gauransh Kapur",
    image: "GauranshKapur.jpg",
    socialUserNames: {
      GitHub: "GK-2006",
      LinkedIn: "gauransh-kapur-510409318"
    },
    teams: ["comms"],
    course: "B. Math",
    year: "2nd"
  },
  {
    name: "Priyankar Biswas",
    image: "PriyankarBiswas.jpg",
    socialUserNames: {
      Email: "gb35638@gmail.com"
    },
    teams: ["comms"],
    course: "B. Math",
    year: "2nd"
  },
  {
    name: "G Sathya Tej",
    image: "SathyaTej.jpeg",
    socialUserNames: {
      Instagram: "sathya_tej_",
      GitHub: "sathya-tej"
    },
    teams: ["comms"],
    course: "B. Math",
    year: "2nd"
  },
  {
    name: "Aayusman Mallick",
    image: "AayusmanMallick.png",
    socialUserNames: {
      Instagram: "aayusmnmallick",
      LinkedIn: "aayusman-mallick-9684b2319"
    },
    teams: ["comms"],
    course: "B. Math",
    year: "2nd"
  },
  {
    name: "Rahul Kumar",
    image: "RahulKumar.jpg",
    socialUserNames: {
      Twitter: "mathsrahulkumar"
    },
    teams: ["comms"],
    course: "B. Math",
    year: "2nd"
  },
  {
    name: "Srijani",
    image: "Srijani.jpg",
    socialUserNames: {
      Instagram: "srijani0308"
    },
    teams: ["comms"],
    course: "B. Math",
    year: "1st"
  },
  {
    name: "Rwittankar Naskar",
    image: "RwittankarNaskar.jpg",
    socialUserNames: {
      Instagram: "ro_dex34"
    },
    teams: ["comms"],
    course: "B. Math",
    year: "1st"
  },
  {
    name: "Aditya Teraiya",
    image: "AdityaTeraiya.jpg",
    socialUserNames: {
      LinkedIn: "adityateraiya",
      GitHub: "adi42wastaken"
    },
    teams: ["comms"],
    course: "B. Math",
    year: "1st"
  },
  {
    name: "Charana Viviksha R",
    image: "CharanaVivikshaR.jpg",
    socialUserNames: {
      Email: "charanavivikshar@gmail.com"
    },
    teams: ["comms"],
    course: "B. Math",
    year: "1st"
  },
  {
    name: "Arkaprovo Das",
    image: "ArkaprovoDas.jpg",
    socialUserNames: {
      Instagram: "arkaprovodas_",
      GitHub: "Arkaprovo-Das"
    },
    teams: ["comms"],
    course: "B. Math",
    year: "2nd"
  },
  {
    name: "Ramdas Singh",
    image: "RamdasSingh.jpeg",
    socialUserNames: {
      Instagram: "maxmight01",
      GitHub: "MaxMight01",
      LinkedIn: "ramdas-max-singh"
    },
    teams: ["design"],
    course: "B. Math",
    year: "2nd"
  },
  {
    name: "Subhojit Maji",
    image: "SubhojitMaji.jpeg",
    socialUserNames: {
      Instagram: "7kiyotakaayanokoji",
      LinkedIn: "subhojit-maji-7bbb29268"
    },
    teams: ["design"],
    course: "B. Math",
    year: "2nd"
  },
  {
    name: "Ruchira Mukherjee",
    image: "RuchiraMukherjee.jpg",
    socialUserNames: {
      Email: "ruchiramj13@gmail.com"
    },
    teams: ["design", "core"],
    course: "M. Math",
    year: "1st"
  }
].sort((a, b) => a.name.localeCompare(b.name))

export const Teams = [
  { name: "Core", abbr: "core" },
  { name: "Question Selection", abbr: "qst" },
  { name: "Technical", abbr: "tech" },
  { name: "Communication", abbr: "comms" },
  { name: "Design", abbr: "design" }
]

export const SocialLinks = {
  Instagram: { icon: <Instagram />, urlPrefix: "https://www.instagram.com/" },
  Facebook: {
    icon: <FacebookRoundedIcon />,
    urlPrefix: "https://www.facebook.com/"
  },
  Twitter: { icon: <XIcon />, urlPrefix: "https://x.com/" },
  LinkedIn: {
    icon: <LinkedInIcon />,
    urlPrefix: "https://in.linkedin.com/in/"
  },
  GitHub: { icon: <GitHub />, urlPrefix: "https://github.com/" },
  Phone: { icon: <CallOutlinedIcon />, urlPrefix: "tel:+91" },
  WhatsApp: { icon: <WhatsAppIcon />, urlPrefix: "https://wa.me/91" },
  Email: { icon: <MailOutlinedIcon />, urlPrefix: "mailto:" },
  Mastodon: {
    icon: <MastodonIcon />,
    urlPrefix: "https://"
  }
}
